export interface NavigationConfig {
  backRoute?: string;
  backLabel?: string;
  showBrandTitle?: boolean;
  pageTitle?: string;
}

/**
 * Navigation configuration map for each route
 * Defines back button behavior and header content for each page
 */
export const NAVIGATION_MAP: Record<string, NavigationConfig> = {
  '/': {
    showBrandTitle: true,
    // No back button on home page
  },
  '/cotd': {
    backRoute: '/',
    backLabel: 'backHome',
    showBrandTitle: false,
    pageTitle: 'cotdTitle',
  },
  '/cotd/session': {
    backRoute: '/cotd',
    backLabel: 'chooseDifferentCategory', 
    showBrandTitle: false,
    pageTitle: 'cotdTitle',
  },
  '/demo': {
    backRoute: '/',
    backLabel: 'backHome',
    showBrandTitle: false,
  },
};

/**
 * Get navigation configuration for a given pathname
 * @param pathname - Current route pathname
 * @returns Navigation configuration object
 */
export const getNavigationConfig = (pathname: string): NavigationConfig => {
  return NAVIGATION_MAP[pathname] || {
    backRoute: '/',
    backLabel: 'backHome',
    showBrandTitle: false,
  };
};